import * as React from "react";
import Modal from "@mui/joy/Modal";
import { MdClose } from "react-icons/md";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import { useState, useEffect } from "react";
import axios from "axios";
import { base_url } from "../../../utils/AxiosConfig";

import { format } from "date-fns";
import CircularProgress from "@mui/joy/CircularProgress";
import user1 from "../../../images/ic_no_person_photo.svg";
import { base_url_image_view_api } from "../../../utils/ImageViewingAPI";

export default function BasicModal(props) {
  const [isCallingAPI, setIsCallingAPI] = useState(false);

  const startOfMonth = new Date();
  startOfMonth.setUTCDate(1);

  const { popUpData, setpopUpData, openViewModal, setOpenViewModal } = props;

  const [timeSheetArray, setTimeSheetArray] = useState(null);

  let initialStartingDate = format(startOfMonth, "yyyy-MMM-dd");
  let initialEndingDate = format(new Date(), "yyyy-MMM-dd");

  console.log(
    "initial popUpData",
    initialStartingDate,
    initialEndingDate,
    popUpData,
    startOfMonth,
  );

  const [timeSheetData, setTimeSheetData] = useState({
    startDate: initialStartingDate,
    endDate: initialEndingDate,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTimeSheetData({
      ...timeSheetData,
      [name]: value,
    });
  };

  // const getTimeSheet = () => {

  //     setIsCallingAPI(true)
  //     console.log("get timesheet ",)

  //     let apiUrl = `${base_url}api/TimesheetList/CUBIX/${popUpData?.EmpId}/${timeSheetData.startDate}/${timeSheetData.endDate}`

  //     console.log("apiUrl timesheet ", apiUrl)

  //     axios.get(apiUrl).then((res) => {

  //         setIsCallingAPI(false)
  //         console.log("res -->", res.data)

  //         setTimeSheetArray(res.data)

  //     }).catch((err) => {

  //         setIsCallingAPI(false)
  //     })
  // }
  const getTimeSheet = async () => {
    setIsCallingAPI(true);
    console.log("Getting timesheet...");

    try {
      const apiUrl = `${base_url}/api/TimesheetList/CUBIX/${popUpData?.EmpId}/${timeSheetData.startDate}/${timeSheetData.endDate}`;

      // https://cubixweberp.com:213/api/TimesheetList/CUBIX/CBX005/2025-07-01/2025-07-05
      console.log("API URL for timesheet:", apiUrl);

      const response = await axios.get(apiUrl);
      console.log("Response →", response.data);
      setTimeSheetArray(response.data);
    } catch (err) {
      console.error("Error fetching timesheet:", err);
      // Optional: show error toast or message
    } finally {
      setIsCallingAPI(false);
    }
  };

  const fetchProfilePic = (ImagePath) => {
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop(); // Extracts the last part (filename with extension)

    // Construct the full URL for the image
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  useEffect(() => {
    getTimeSheet();
  }, []);

  return (
    <Modal
      open={openViewModal}
      onClose={() => {
        setOpenViewModal(false);
        setpopUpData(null);
      }}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <Sheet
        variant="outlined"
        className="relative  w-[72vw]   bg-white rounded-xl shadow-2xl  overflow-hidden"
      >
        <button
          onClick={() => setOpenViewModal(false)}
          className="absolute right-4 top-4 z-10 rounded-full p-1 hover:bg-red-400 transition"
        >
          <MdClose className="w-5 h-5 text-white" />
        </button>
        <div className="p-3   bg-[#2663EB]">
          <h2 className="text-xl font-semibold text-white">View Timesheet</h2>
        </div>

        <div className="p-6 space-y-6">
          {/* Header + Date Controls */}
          <div className="flex flex-col sm:flex-row gap-6 items-start sm:items-end justify-between">
            {/* Employee Info */}
            <div className="flex items-center gap-4">
              <div className="shrink-0">
                {popUpData?.imagepath ? (
                  <img
                    src={fetchProfilePic(popUpData.imagepath)}
                    alt={popUpData?.Name}
                    className="w-20 h-20 rounded-full object-cover border-2 border-gray-100 shadow-sm"
                  />
                ) : (
                  <img
                    src={user1}
                    alt="Default avatar"
                    className="w-20 h-20 rounded-full object-cover border-2 border-gray-100 shadow-sm"
                  />
                )}
              </div>

              <div>
                <div className="font-medium text-gray-900 text-lg">
                  {popUpData?.Name}
                </div>
                <div className="text-sm text-gray-600">{popUpData?.EmpId}</div>
                <div className="text-sm text-gray-500 mt-0.5">
                  {popUpData?.JobTitle}
                </div>
              </div>
            </div>

            {/* Date Range + View Button */}
            <div className="flex flex-col bg-green-100 sm:flex-row items-start sm:items-end gap-4 bg-gray-50 p-4 rounded-lg border-1 border-green-500 w-full sm:w-auto">
              <div className="flex gap-3 ">
                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    Start Date
                  </label>
                  <input
                    type="date"
                    id="startDate"
                    name="startDate"
                    value={timeSheetData.startDate}
                    onChange={handleChange}
                    max={new Date().toISOString().split("T")[0]}
                    className="w-36 px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500/30 focus:border-indigo-500 outline-none"
                  />
                </div>

                <div>
                  <label className="block text-xs font-medium text-gray-600 mb-1">
                    End Date
                  </label>
                  <input
                    type="date"
                    id="endDate"
                    name="endDate"
                    value={timeSheetData.endDate}
                    onChange={handleChange}
                    max={new Date().toISOString().split("T")[0]}
                    className="w-36 px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500/30 focus:border-indigo-500 outline-none"
                  />
                </div>
              </div>

              <button
                onClick={getTimeSheet}
                className="px-5 py-2 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition-colors shadow-sm whitespace-nowrap"
              >
                View
              </button>
            </div>
          </div>

          {/* Table Section */}
          {isCallingAPI ? (
            <div className="flex justify-center py-12">
              <CircularProgress size="lg" />
            </div>
          ) : (
            <div className="max-h-[380px] overflow-auto rounded-lg border border-gray-200">
              <table className="w-full text-sm text-left text-gray-700">
                <thead className="bg-[#2663EB] text-white uppercase tracking-wide text-xs">
                  <tr>
                    <th className="px-4 py-3 font-medium">Sl No.</th>
                    <th className="px-4 py-3 font-medium">Tot Wage</th>
                    <th className="px-4 py-3 font-medium">Date</th>
                    <th className="px-4 py-3 font-medium">Entry Date</th>
                    <th className="px-4 py-3 font-medium">Nr Hrs</th>
                    <th className="px-4 py-3 font-medium">Nr Rate</th>
                    <th className="px-4 py-3 font-medium">Ot Hrs</th>
                    <th className="px-4 py-3 font-medium">Ot Rate</th>
                    <th className="px-4 py-3 font-medium">Ots Hrs</th>
                    <th className="px-4 py-3 font-medium">Ots Rate</th>
                    <th className="px-4 py-3 font-medium">Remarks</th>
                    <th className="px-4 py-3 font-medium">Type</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {timeSheetArray?.map((item) => (
                    <tr
                      key={item.slno}
                      className="hover:bg-gray-50/70 transition-colors"
                    >
                      <td className="px-4 py-3">{item.slno}</td>
                      <td className="px-4 py-3 font-medium">{item.tot_wage}</td>
                      <td className="px-4 py-3">
                        {new Date(item.Date).toLocaleDateString("en-GB", {
                          day: "numeric",
                          month: "numeric",
                          year: "numeric",
                        })}
                      </td>
                      <td className="px-4 py-3">
                        {new Date(item.entry_date).toLocaleDateString("en-GB", {
                          day: "numeric",
                          month: "numeric",
                          year: "numeric",
                        })}
                      </td>
                      <td className="px-4 py-3">{item.nr_hrs || "-"}</td>
                      <td className="px-4 py-3">{item.nr_rate || "-"}</td>
                      <td className="px-4 py-3">{item.ot_hrs || "-"}</td>
                      <td className="px-4 py-3">{item.ot_rate || "-"}</td>
                      <td className="px-4 py-3">{item.ots_hrs || "-"}</td>
                      <td className="px-4 py-3">{item.ots_rate || "-"}</td>
                      <td className="px-4 py-3 max-w-xs truncate">
                        {item.remarks || "-"}
                      </td>
                      <td className="px-4 py-3">{item.type || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {!timeSheetArray?.length && (
                <div className="py-10 text-center text-gray-500">
                  No timesheet entries found for the selected period.
                </div>
              )}
            </div>
          )}
        </div>
      </Sheet>
    </Modal>
  );
}
